import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';
import './utils/chartSetup';
import "bulma/css/bulma.css";
import 'font-awesome/css/font-awesome.min.css';
import 'bulma-floating-button/dist/css/bulma-floating-button.min.css'
import './App.css';

axios.defaults.withCredentials = true;

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    
      <App />
    
  </React.StrictMode>
);